export const iconFontAwesomeConnectivityBluetooth = (
	<i className="fa-solid fa-bluetooth"></i>
);
